import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {some, isEmpty, sortBy, map} from 'lodash';
import classNames from 'classnames';
import {
  editCommunityServiceEvent,
  addNewCommunityServiceEvent,
} from 'shared/portfolio/actions/community-service';
import {Store} from 'src/types/store';
import Card from '../card';
import Section from '../section';
import CommunityServiceEvent from './community-service-event';
import PortfolioSectionHeader from '../portfolio-section-header';
import EmptyPlaceholder from '../empty-placeholder';
import CommunityServiceFormCard from 'shared/portfolio/components/community-service/community-service-form-card';
import TwoColumnMasonry from 'shared/portfolio/components/two-column-masonry';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import PortfolioIcon from '../portfolio-icon/portfolio-icon';

const CommunityService = () => {
  const mq = useMediaQuery();
  const dispatch = useDispatch();
  const communityServiceEvents = useSelector((state: Store) => state.communityServiceEvents);
  const editing = some(communityServiceEvents, 'editing');
  const handleAddClick = useCallback(
    () => dispatch(addNewCommunityServiceEvent({scrollTo: true})),
    [dispatch]
  );

  useEffect(() => {
    window.Raise.vent.on('add:communityService', handleAddClick);
  }, [handleAddClick]);

  let communityServiceItems: React.ReactNode = null;

  if (isEmpty(communityServiceEvents)) {
    communityServiceItems = (
      <div className="portfolio-sections column">
        <EmptyPlaceholder
          onClick={handleAddClick}
          header="Add Community Service"
          description="Up to $20 per hour"
          portfolioItemType="community-service"
        />
      </div>
    );
  } else {
    const sortedCommunityServiceEvents = sortBy(
      communityServiceEvents,
      (communityServiceEvent) => -communityServiceEvent.createdAt
    );

    communityServiceItems = (
      <TwoColumnMasonry>
        {map(sortedCommunityServiceEvents, (communityServiceEvent) => {
          if (communityServiceEvent.editing) {
            return (
              <div
                className={classNames('portfolio-sections column', {
                  editing: communityServiceEvent.editing,
                })}
                key={communityServiceEvent._id}
              >
                <CommunityServiceFormCard communityService={communityServiceEvent} />
              </div>
            );
          } else {
            return (
              <div className="portfolio-sections column" key={communityServiceEvent._id}>
                <Card
                  id={communityServiceEvent._id}
                  active={!!communityServiceEvent.scrollTo}
                  onClick={() => {
                    dispatch(editCommunityServiceEvent(communityServiceEvent));
                  }}
                >
                  <CommunityServiceEvent communityServiceEvent={communityServiceEvent} />
                </Card>
              </div>
            );
          }
        })}
      </TwoColumnMasonry>
    );
  }

  return (
    <div>
      <PortfolioSectionHeader
        title="Community Service"
        displayNew={!editing && !(mq.XS && !Object.keys(communityServiceEvents).length)}
        addNew={handleAddClick}
        sectionName="community-service"
      >
        <PortfolioIcon type="communityService" size={mq.XS ? 40 : 56} />
      </PortfolioSectionHeader>
      <Section>
        <div id="community" className="portfolio-sections main-section" />
        {communityServiceItems}
      </Section>
    </div>
  );
};

export default CommunityService;
